import React, { Component } from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-16 border-t border-gray-800" data-id="element-150">
      <div className="container mx-auto px-4 md:px-6" data-id="element-151">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-152">
          {/* Brand */}
          <div data-id="element-153">
            <div className="flex items-center gap-3 mb-6" data-id="element-154">
              <img src="https://cdn.magicpatterns.com/uploads/dSUoJFewu2oS1dagyRHpgT/IconOnly.png" alt="Plastic Engineering Solutions Logo" className="h-10 w-auto object-contain" data-id="element-155" />
              <span className="text-white font-bold text-lg" data-id="element-156">
                Plastic Engineering Solutions
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-157">
              Your trusted partner for medical device components and packaging.
              Delivering precision, quality, and reliability since 2024.
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-158">
            <h3 className="text-white font-bold mb-6" data-id="element-159">Contact Info</h3>
            <ul className="space-y-4" data-id="element-160">
              <li className="flex items-start gap-3" data-id="element-161">
                <MapPin className="h-5 w-5 text-accent mt-0.5" data-id="element-162" />
                <span data-id="element-163">
                  Based in Saratoga Springs, Utah
                  <br data-id="element-164" />
                  Serving Clients Nationwide
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-165">
                <Phone className="h-5 w-5 text-accent" data-id="element-166" />
                <a href="tel:+18016186677" className="hover:text-white transition-colors" data-id="element-167">
                  (801) 618-6677
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-168">
                <Mail className="h-5 w-5 text-accent" data-id="element-169" />
                <a href="mailto:parker@plastices.com" className="hover:text-white transition-colors" data-id="element-170">
                  parker@plastices.com
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-171">
            <h3 className="text-white font-bold mb-6" data-id="element-172">Services</h3>
            <ul className="space-y-3 text-sm" data-id="element-173">
              <li data-id="element-174">
                <a href="#process" className="hover:text-accent transition-colors" data-id="element-175">
                  Injection Molding Process
                </a>
              </li>
              <li data-id="element-176">
                <a href="#expertise" className="hover:text-accent transition-colors" data-id="element-177">
                  Medical Device Components
                </a>
              </li>
              <li data-id="element-178">
                <a href="#expertise" className="hover:text-accent transition-colors" data-id="element-179">
                  Dietary Supplement Packaging
                </a>
              </li>
              <li data-id="element-180">
                <a href="#materials" className="hover:text-accent transition-colors" data-id="element-181">
                  Material Consultation
                </a>
              </li>
              <li data-id="element-182">
                <a href="#partnership" className="hover:text-accent transition-colors" data-id="element-183">
                  Quality Assurance
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-500" data-id="element-184">
          <p data-id="element-185">
            &copy; {new Date().getFullYear()} Plastic Engineering Solutions. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}